import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwedish = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_198_9346)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.82621 8.69566H19.9154C19.2762 3.78914 15.0808 0 10.0001 0C9.25344 0 8.52613 0.0825391 7.82617 0.237695V8.69566H7.82621Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.21745 8.69555V1.21582C2.47159 2.71402 0.505928 5.46211 0.0847168 8.69559H5.21745V8.69555Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.21741 11.3047H0.0847168C0.505928 14.5382 2.47159 17.2863 5.21745 18.7844L5.21741 11.3047Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.82617 11.3047V19.7627C8.52613 19.9178 9.25344 20.0004 10.0001 20.0004C15.0808 20.0004 19.2762 16.2112 19.9154 11.3047H7.82617V11.3047Z",
					fill: "#0052B4"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_198_9346",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSwedish);
export { ForwardRef as ReactComponent };
